export const DEFAULT_WORKSPACE_NAME = "Private workspace";
export const PRETTY_URL_NOT_FOUND_PAGE = "%_-404-_%";
export const PRETTY_URL_ROOT_PAGE = "";
export const DEFAULT_TOP_TOOLBAR_HEIGHT = 40;
export const HIGHLIGHT_PRE = "__HL_PRE__";
export const HIGHLIGHT_POST = "__HL_POST__";
